// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"155":"ca4585b5","626":"3cfaf594","627":"ca4585b5","758":"d79a3b3f","904":"ca4585b5","987":"fe5cf24b"}[chunkId] + ".chunk.css";
};